import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import CatalogManagementPage from "../pages/CatalogManagementPage";

const authUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`;
const catalogUrl = `${process.env.REACT_APP_BACKEND_URL}/api/catalog/types`;

export default function ProtectedCatalog() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await axios.get(authUrl, { withCredentials: true });
        await axios.get(catalogUrl, { withCredentials: true });
        setUser(response.data);
      } catch (error) {
        navigate(error.response?.status === 403 ? "/dashboard" : "/login", {
          replace: true,
        });
      }
    };
    verify();
  }, [navigate]);

  const logout = async () => {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`,
      {},
      { withCredentials: true },
    );
    navigate("/login", { replace: true });
  };

  if (!user) {
    return (
      <main className="auth-check" data-testid="catalog-auth-check-state" />
    );
  }

  return <CatalogManagementPage user={user} onLogout={logout} />;
}
